export const default_filter_form_state = {
  start_date: null,
  range_name: null,
  finish_date: null,
  include_archived: false,
  parameter_name: null,
  parameter_value: null,
  created_by: null,
  max_rows: 50,
  job_state: null,
  refresh_timeout: null,
  min_refresh: 0,
};

export const date_range = ['Custom', 'Today', 'Yesterday', 'Current Week', 'Last Week', 'Current Month'] as const;
export type DateRange = typeof date_range;
